var React = require('react');

function IconWantedlyInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M35.287 15.42A4.711 4.711 0 0040 10.71C40 8.109 37.89 6 35.287 6a4.711 4.711 0 00-4.712 4.71c0 2.6 2.11 4.71 4.712 4.71z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.205 24.22c-.283-.183-1.088-1.262-3.315-6.577a14.796 14.796 0 00-.39-.868L8.14 6.26H.333l11.413 27.542a.322.322 0 00.478.144.322.322 0 00.12-.144l3.923-9.386a.162.162 0 00-.062-.196zM30.832 24.22c-.283-.183-1.088-1.262-3.315-6.577-.14-.334-.27-.621-.392-.869L22.768 6.26H14.96l11.413 27.542a.322.322 0 00.478.144.322.322 0 00.12-.144l3.923-9.385a.164.164 0 00-.062-.197z","key":1})]);
}

IconWantedlyInline.defaultProps = {"width":"40","height":"40"};

module.exports = IconWantedlyInline;

IconWantedlyInline.default = IconWantedlyInline;
